// export const exerciseOptions = {
//   method: "GET",
//   headers: {
//     "X-RapidAPI-Key": process.env.RAPID_API_KEY,

//     "X-RapidAPI-Host": "exercisedb.p.rapidapi.com",
//   },
// };
export const exerciseOptions = {
  method: "GET",
  headers: {
    "X-RapidAPI-Key": "a07ad574b1msh69fff94a921ee28p1eb9c4jsne3138e301b59",
    "X-RapidAPI-Host": "work-out-api1.p.rapidapi.com",
  },
};
export const fetchData = async (url, options) => {
  try {
    const response = await fetch(url, options);
    if (!response.ok) {
      throw new Error("Network response not ok");
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error);
  }
};

// url: "https://exerciseapi3.p.rapidapi.com/exercise/all",

// a07ad574b1msh69fff94a921ee28p1eb9c4jsne3138e301b59
